import { render, staticRenderFns } from "./AddPricelistDlg.vue?vue&type=template&id=fb3eb5e6&"
import script from "./AddPricelistDlg.vue?vue&type=script&lang=js&"
export * from "./AddPricelistDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddPricelistDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports